/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutMedicalInformationRequestBodyTypename = "PutMedicalInformationRequestBody" as const;

/**
 *
 * @export
 * @interface PutMedicalInformationRequestBody
 */
export interface PutMedicalInformationRequestBody {
  /**
   *
   * @type {Array<string>}
   * @memberof PutMedicalInformationRequestBody
   */
  medicalInformations: Array<string>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutMedicalInformationRequestBody
   */
  readonly __typename?: string;
}

export function PutMedicalInformationRequestBodyFromJSON(json: any): PutMedicalInformationRequestBody {
  return PutMedicalInformationRequestBodyFromJSONTyped(json, false);
}

export function PutMedicalInformationRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutMedicalInformationRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutMedicalInformationRequestBodyTypename,

    medicalInformations: json["medical_informations"],
  };
}

export function PutMedicalInformationRequestBodyToJSON(object?: PutMedicalInformationRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    medical_informations: value.medicalInformations,
  };
}
